'use client';

import { LazyLottie } from './LazyLottie';
import { IAnimationProps } from './types';

/**
 * -----------------------------------------------------------------------------
 * Renders a Lottie animation as a shown when an error occurs while fetching
 * the data
 */
export function SomethingWentWrongAnimation(props: IAnimationProps) {
  const loadAnimation = () =>
    import('./raw-animation-data/error/something-went-wrong-green.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="SomethingWentWrongAnimation"
    />
  );
}
